/**
 * Permission codes the transfer pricing screens declare an interest in
 * (`server/internal/tp/permissions.go`, FSD FIN-FR-031).
 *
 * `tp.policy.manage` and `tp.policy.approve` are held apart (an SoD pair):
 * whoever sets the price method must not be the one who approves it. Approval
 * itself happens in the Approvals Inbox under document type `tp.policy`.
 */

export const TP_PERMISSIONS = {
  /** View policies, quote a price and read the departures report. */
  read: 'tp.policy.read',
  /** Draft, edit, submit, discard and supersede policies; add or remove basis evidence. */
  manage: 'tp.policy.manage',
  /** Approve or reject a policy (Approvals Inbox, doc type `tp.policy`). */
  approve: 'tp.policy.approve',

  /** The intercompany rule list a policy is drafted against (`GET /foundation/intercompany-rules`). */
  intercompanyRuleRead: 'org.legal_entity.intercompany_read',
  /** Captured intercompany transactions: the departures drill when a row carries no journal id. */
  icTransactionRead: 'interco.pair.read',
  /** The GL journal route a departure links to directly (`/gl/journal-entries/:id`). */
  journalRead: 'gl.journal.read',
} as const

export type TpPermission = (typeof TP_PERMISSIONS)[keyof typeof TP_PERMISSIONS]

/** The approvals document type a policy is submitted under (`tp/policy.go`). */
export const TP_POLICY_DOC_TYPE = 'tp.policy'
